export default __webpack_public_path__ + "static/media/SIAM-FME-2025-LOBvAMM.b7eb6e71.pdf";